import styled from 'styled-components/macro';
import { hardWhite } from '../../config/colors';

export const Image = styled.img`
  width: 100%;
  height: 100%;
  border-radius: ${(props) => (props.$radius ? '50%' : 'none')};
  border: 3px solid ${hardWhite};
`;
